<app-alert type="warning">
  <ng-container alert-title>{{ 'payout.change-alert.title' | customLocale }}</ng-container>
  <ng-container alert-body>{{ 'payout.change-alert.description' | customLocale }}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="payout.change-alert.cancel"
                  class="primary outline"
                  (onclick)="onCancel()">
    </on-ui-button>
    <on-ui-button label="payout.change-alert.change"
                  class="primary"
                  (onclick)="onChange()">
    </on-ui-button>
  </ng-container>
</app-alert>
